import React, { Component } from 'react';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('TRANSACTION_REPORT_LEDGERS', LOG_LEVELS.DEBUG);

class ReportLedgers extends Component {

  render() {
    log.debug('render(): ', this.props);

    if (!this.props.src) {
      return(
        <div><LanguageStringResolver string='transactionBlank_noData'/></div>
      )
    }

    return(
      <table className="mb20">
        <thead>
          <tr>
            <th className="quarter-width"><span><LanguageStringResolver string='transactionInvoice_country'/></span></th>
            <th><span><LanguageStringResolver string='transactionInvoice_ledger'/></span></th>
          </tr>
        </thead>
        <tbody>
          {this.props.src.map((item, index) => (
            <tr key={index}>
              <td>{item.country}</td>
              <td>{item.ledgerType}</td>
            </tr>
          ))}
        </tbody>
      </table>
   );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(ReportLedgers);
